<template>
    <modal title="Add from Existing Vehicle" width="45" class="sm:62" :showModal="showModal" @close-modal="closeModal">
        <div class="w-full">
            <div class="mt-8">
                <div class="">
                    <label class="label">Vehicle Type</label>
                    <el-select filterable v-model="routeMedium" placeholder="Select">
                        <el-option label="Truck" value="Truck"> </el-option>
                        <el-option label="Bike" value="Bike"> </el-option>
                        <el-option label="Van" value="Van"> </el-option>
                        <el-option label="Car" value="Car"> </el-option>
                        <el-option label="Lorry" value="Lorry"> </el-option>
                    </el-select>
                </div>
            </div>

            <div class="mt-2">
                <div class="">
                    <label class="label">Vehicle</label>
                    <el-select filterable v-model="vehicle" placeholder="Select">
                        <el-option v-for="fleet in filteredFleet" :key="fleet.id"
                            :label="`${fleet.vehicleNumber} (${fleet.terminal.address})`" :value="fleet.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div class="mt-24 flex justify-end">
                <button
                @click="createFleet"
                class="px-4 py-2 rounded bg-primary-yellow">
                    Add
                </button>
                <button @click="closeModal" class="px-4 py-2 rounded ml-4">
                    Cancel
                </button>
            </div>
        </div>
    </modal>
</template>

<script>


export default {
    props: {
        showModal: Boolean,
    },
    data() {
        return {
            vehicle: '',
            routeMedium: '',
            fleets: [],
            filteredFleet: []
        }
    },
    computed: {
        setparams() {
            return { type: 'private' };
        },
    },
    watch: {
        routeMedium(val) {
            let filters = this.fleets.filter((item) => item?.vehicletype == val)
            console.log(">>>>>>>>>>>>>>>>>>", filters)
            this.filteredFleet = filters
        }
    },
    mounted() {
        this.getUserFleets(this.setparams)
    },
    methods: {
        async getUserFleets(params) {
            this.loading = true;

            try {
                const response = await this.$_getUserMyFleet(params);
                this.fleets = response?.data?.data;
                // this.totalFleets = response.data?.totalCount;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        async createFleet() {
           const pickedFleet = this.filteredFleet.find((item)=> item.id === this.vehicle)
           delete pickedFleet.id
           delete pickedFleet.fleetReference
           delete pickedFleet.driver
           console.log("fleets===========================", pickedFleet);
            try {
                await this.$_createFleet({payload: { ...pickedFleet }});

                this.generateToast("Vehicle successfully created!", "success");
                this.$router.push({ name: "Vehicles" });
            } catch (error) {
                this.handleError(error);
            }
        },
        closeModal() {
            this.$emit("close-modal");
        },
    }
};
</script>

<style scoped>
.option_table {
    @apply py-3 px-4 flex items-center my-3 w-full;

    span {
        @apply px-4 w-full cursor-pointer
    }
}

.liner {
    @apply h-[2px] border-none bg-gray-300 w-full my-2
}
</style>